export function buildAutoscheduleAcceptance(preview, days) {
  const accepted_dates = days
    .filter((day) => day.status === "accepted")
    .map((day) => day.date);
  return {
    ...preview,
    accepted_dates,
    new_schedule: preview.new_schedule.filter((shift) => accepted_dates.includes(shift.date)),
    new_schedule_labor: preview.new_schedule_labor.filter((row) => accepted_dates.includes(row.date)),
  };
}
